import { useEffect } from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import './BlogPostRenderer.scss';

function EditorStateLoader({ contentJson }) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!contentJson) return;
    try {
      const newState = editor.parseEditorState(
        typeof contentJson === 'string' ? contentJson : JSON.stringify(contentJson)
      );
      editor.setEditorState(newState);
    } catch (e) {
      console.error('BlogPostRenderer: failed to parse editorState', e);
    }
  }, [contentJson, editor]);
  return null;
}

const NODES = [HeadingNode, QuoteNode, ListNode, ListItemNode, LinkNode, AutoLinkNode];

const THEME = {
  heading: { h2: 'blog-h2', h3: 'blog-h3', h4: 'blog-h4' },
  quote: 'blog-quote',
  list: { ul: 'blog-ul', ol: 'blog-ol', listitem: 'blog-li', nested: { listitem: 'blog-li-nested' } },
  link: 'blog-link',
  text: { bold: 'blog-bold', italic: 'blog-italic', underline: 'blog-underline', code: 'blog-code' },
  paragraph: 'blog-paragraph',
};

export function BlogPostRenderer({ contentJson }) {
  if (!contentJson) return null;

  const initialConfig = {
    namespace: 'BlogPostRenderer',
    editable: false,
    nodes: NODES,
    theme: THEME,
    onError: (err) => console.error('Lexical renderer error:', err),
  };

  return (
    <div className="blog-post-renderer">
      <LexicalComposer initialConfig={initialConfig}>
        <RichTextPlugin
          contentEditable={<ContentEditable className="blog-renderer-content" />}
          placeholder={null}
          ErrorBoundary={LexicalErrorBoundary}
        />
        <ListPlugin />
        <LinkPlugin />
        <EditorStateLoader contentJson={contentJson} />
      </LexicalComposer>
    </div>
  );
}
